import { gql } from 'apollo-angular';

export interface UserNotification {
  id: string;
  description: string;
  subscribed: boolean;
}

export const userNotification = gql`
  fragment userNotification on UserNotification {
    id
    description
    subscribed
  }
`;
